import React from 'react'
import Lottie from 'lottie-react'
import gear from '../lotties/gear'

export const Loading = () => <Lottie style={{ width: '200px', margin: 'auto' }} animationData={gear} loop />
